import { defineMessages } from "react-intl";

export const messages = defineMessages({
  defaultVariant: {
    id: "vZMs8f",
    defaultMessage: "Default",
    description: "default product variant indicator",
  },
  addVariant: {
    id: "3C3Nj5",
    defaultMessage: "Add variant",
    description: "button",
  },
  newVariant: {
    id: "IqRBql",
    defaultMessage: "New variant",
    description: "variant name",
  },
});
